import React, { useCallback, useEffect, useState } from "react";
import { Formik } from "formik";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

import {
  Label,
  TextBox,
  TextArea,
} from "../../../primitives";
import styles from "./styles.module.scss";
import { model, validation } from "./constant";
import { steps } from "../constant";
import { getUserTeams } from "modules/teams/teams.action";
import NewProjectAccess from "../../../../common/components/newProjectSharedComponents/newProjectAccess";
import NewProjectTeam from "../../../../common/components/newProjectSharedComponents/newProjectTeam";
import NewProjectEvaluation from "../../../../common/components/newProjectSharedComponents/newProjectEvaluation";
import FordEuropeTemplate from "modules/projects/newProjectFord/stepOne/europeTemplate";
import { httpGet } from "../../../../common/httpCall";

const StepOneComponent = (props) => {
  const {
    formRef,
    moveNextStep,
    defaultModel,
  } = props;
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [initModel, setInitModel] = useState(model);
  const [proposalData, setProposalData] = useState(null);

  useEffect(() => {
    httpGet({
      call: 'ford/project_field_templates'
    }).subscribe(res => {
      if (res.response) {
        const proposal_for_implementation = res.response.proposal_for_implementation.data.map(elem => ({
          id: elem.id,
          ...elem.attributes
        }));
        const proposal_for_prototype = res.response.proposal_for_prototype.data.map(elem => ({
          id: elem.id,
          ...elem.attributes
        }));
        const project_idea_modal = res.response.project_idea_modal.data.map(elem => ({
          id: elem.id,
          ...elem.attributes
        }));

        setProposalData({
          project_idea_modal,
          proposal_for_implementation,
          proposal_for_prototype
        })
      }
    })
  }, []);

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    stepOneReducer: { stageTemplates },
  } = useSelector((state) => state);

  const getDefaultEvalTemplate = () => {
    if (stageTemplates && stageTemplates?.length > 0) {
      const getStage = stageTemplates.find((template) => template.default_template);
      return getStage?.id;
    }
  };

  const onSubmitValue = (values) => {
    const getSelectedTemplate = stageTemplates.filter(t => t.id === values.stage_template_id) || [];
    const makeStageTemplateObj = {
      val: values.stage_template_id,
      obj: getSelectedTemplate,
    };

    const selectedPlant = values?.selectedPlant;

    if (selectedPlant?.id?.length > 0 && selectedPlant.areas?.length > 0 && !selectedPlant?.selectedAreas?.length) {
      return;
    }

    moveNextStep(steps.step_two, {
      ...values,
      stage_template_id: makeStageTemplateObj,
      userId: session.id,
      councilId: selectedCouncil.id,
    });
  };

  useEffect(() => {
    if (stageTemplates?.length) {
      const getProj = localStorage.getItem("new_project");
      const newProject = getProj ? JSON.parse(getProj) : {};

      setInitModel((prev) => ({
        ...prev,
        ...defaultModel || {},
        ...newProject,
        stage_template_id: getDefaultEvalTemplate(),
      }));
    }
  }, [stageTemplates]);

  useEffect(() => {
    dispatch(
      getUserTeams({
        enqueueSnackbar,
        query: {
          items: 1000,
        },
      })
    );
  }, []);

  const isEuropeMFG = useCallback((values) => {
    const getStage = stageTemplates?.find(s => s.id === (values?.stage_template_id?.val || values?.stage_template_id));
    return getStage?.name === 'Europe MFG Innovation' || getStage?.name === 'US MFG Innovation';
  }, [stageTemplates]);

  return (
    <div className={styles.inner}>
      <h4 className={classNames("bold", styles.innerTitle)}>
        Create Project
      </h4>
      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={initModel}
        validationSchema={validation}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          onSubmitValue(values);
        }}
      >
        {({ handleSubmit, ...formikprops }) => {
          const isItEuropeTemplate = isEuropeMFG(formikprops.values);

          return (
            <form onSubmit={handleSubmit}>
              {
                isItEuropeTemplate ? (
                  <FordEuropeTemplate formikprops={formikprops} proposalData={proposalData} />
                ) : (
                  <>
                    <div className={styles.formElement}>
                      <Label>Project name</Label>
                      <TextBox
                        type="text"
                        name="name"
                        placeholder="Project name"
                        formProps={formikprops}
                        className={styles.textBox}
                      />
                    </div>
                    <div className={styles.formElement}>
                      <NewProjectAccess formikprops={formikprops} />
                    </div>
                    {formikprops.values.visibility === "team" && (
                      <div className={styles.formElement}>
                        <NewProjectTeam setFieldValue={formikprops.setFieldValue} />
                      </div>
                    )}
                    <NewProjectEvaluation formikprops={formikprops} />
                    <div className={styles.formElement}>
                      <Label>Problem Statement</Label>
                      <TextArea
                        type="text"
                        name="description"
                        placeholder="Describe the problem you are trying to solve, the project goal, or description."
                        className={styles.textBox}
                        formProps={formikprops}
                        rows={8}
                      />
                    </div>
                  </>
                )
              }
            </form>
          )
        }}
      </Formik>
    </div>
  );
};

export default React.memo(StepOneComponent);
